<template>
  <div class="max-w-md mx-auto">
    <div class="border border-gray-300 shadow-md m-2">
      <div class="mx-3 my-4 flex justify-between content-center" @click="toggleTransaction">
        <p class="text-gray-600 text-md">
          <font-awesome-icon
            v-if="type === 'income'"
            icon="arrow-alt-circle-down"
            class="mr-2 text-green-400"
          />
          <font-awesome-icon
            v-if="type === 'outcome'"
            icon="arrow-alt-circle-up"
            class="mr-2 text-red-500"
          />
          {{ date | formatDate }}
        </p>
        <p v-if="type === 'income'" class="text-gray-700 font-bold whitespace-pre">
          <span v-if="type === 'income'" class="text-green-600">+</span>
          <span>£{{ amount }}</span>
        </p>
        <p v-if="type === 'outcome'" class="text-gray-700 font-bold">
          <span v-if="type === 'outcome'" class="text-red-600">-</span>
          <span>£{{ amount }}</span>
        </p>
      </div>

      <transition name="showin">
        <div v-if="open" class="text-xs mx-3 my-4">
          <p class="italic">Note:</p>
          <p v-if="description">{{ description }}</p>
          <p v-if="!description">N/A</p>
          <div class="flex content-center justify-end">
            <a
              href="#"
              class="text-red-500 border border-red-500 px-2 py-1 mr-3 rounded"
              @click.prevent="$router.push('delete-transaction/' + id)"
            >Delete</a>
            <a
              href="#"
              class="text-white bg-indigo-500 px-2 py-1 rounded"
              @click.prevent="$router.push('edit-transaction/' + id)"
            >Edit</a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import store from "./../store/index";
export default {
  name: "Transaction",
  data() {
    return {
      //
    };
  },
  props: ["id", "amount", "date", "description", "type", "open"],
  methods: {
    toggleTransaction() {
      const action = this.open ? "closeTransaction" : "openTransaction";
      store.dispatch(action, { id: this.id });
    },
    deleteTransaction(id) {
      store.dispatch("deleteTransaction", {
        userId: this.userId,
        transactionId: this.id
      });
    }
  },
  computed: {
    userId() {
      return this.$store.getters.user.id;
    }
  },
  filters: {
    formatDate(isoDate) {
      if (!isoDate) {
        return "";
      }

      return new Date(isoDate).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>